import { ASTGeneratedOutput, Generator } from "@core/services/common/Generator";
import { CapacityAnalyseFiltersResponse } from "@core/store/types/admin/offers/capacity";

export default function trafficRequestsAnalyseChart (
  offerId: string,
  webmasterId: string,
  filters: CapacityAnalyseFiltersResponse,
  isShowRedemption: boolean
): ASTGeneratedOutput {
  const params = {
    include: isShowRedemption ? ["conversionPayout"] : []
  };
  
  const gqlObject = {
    operation: "capacityGraphByWebmaster",
  
    fields: [
      {
        offer: [
          "id",
          "intId",
          {
            detail: [
              "name"
            ]
          },
          {
            finance: [
              "currency"
            ]
          }
        ]
      },
      {
        webmaster: [
          "id",
          "intId",
          "login"
        ]
      },
      "countLeadsIntegrated",
      "conversionApprove",
      "countLeadsAccepted",
      "softCapacity",
      "webmasterPayout",
      "date"
    ],
    
    variables: {
      offerId: {
        type: "Uid!",
        value: offerId
      },
      webmasterId: {
        type: "Uid!",
        value: webmasterId
      },
      filters: {
        type: "CapacityGraphByWebmasterCriteriaFilters",
        value: filters
      }
    }
  };
  
  return Generator.query(gqlObject, params);
}